// extracted by mini-css-extract-plugin
module.exports = {"disclaimer":"signup-module--disclaimer--1_xtE","subheader":"signup-module--subheader--3REg0","infotext":"signup-module--infotext--aa_Yu","input":"signup-module--input--1t54z"};